import { Outlet } from 'react-router-dom';
import BottomNav from './BottomNav';

export default function AppLayout() {
  return (
    <div className="flex flex-col h-screen max-w-md mx-auto bg-white">
      <div className="flex-1 overflow-y-auto pb-16">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}